import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import MelCTA from '@toasttab/onTheLine/src/components/MDS/CTA/MelCTA'

const StickyMelCTA = ({ melCTA }: any) => {
  const [parentToggle, setParentToggle] = useState(false)
  const stickyCtaClass = classNames({
    'sticky md:hidden top-[61px] pt-6 bg-white z-[40]': true,
    'max-h-[95vh] overflow-y-scroll': parentToggle
  })

  return (
    <div className={stickyCtaClass}>
      <MelCTA melCTA={melCTA} parentToggle={setParentToggle} />
    </div>
  )
}

export default StickyMelCTA
